// extracted by mini-css-extract-plugin
export default {"svg":"Loader_svg__-Y55s","wrapper":"Loader_wrapper__dP0mX","smallSize":"Loader_smallSize__+4aA0"};